export const page = async () => {
    
    document.querySelector<HTMLElement>('.container-game').style.height = "auto";
    document.querySelector<HTMLElement>('#container-canvas').style.width = "fit-content";

    // Desktop screens
    if(window.innerWidth > 1350){
        document.querySelector<HTMLElement>('.container-game').style.padding = "45px 0 35px 0";
    }

    // Laptop screens
    if(window.innerWidth > 520 && window.innerWidth < 1350){
        document.querySelector<HTMLElement>('.container-game').style.padding = "35px 0 25px 0";
    }

    // Mobile screens
    if(window.innerWidth <= 520){

        window.onload = () => {

            document.querySelector<HTMLElement>('.container-game').style.padding = "24px 0 13px 0";
            document.querySelector<HTMLElement>('#container-canvas').style.height = "fit-content";
        };
    }
}